import { render } from "./PrintersManagement.vue?vue&type=template&id=97089898&scoped=true"
import script from "./PrintersManagement.vue?vue&type=script&lang=js"
export * from "./PrintersManagement.vue?vue&type=script&lang=js"

import "./PrintersManagement.vue?vue&type=style&index=0&id=97089898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97089898"]])

export default __exports__